import { View } from "@towersystems/roam-common-native";
import Animated, {
  useAnimatedReaction,
  useAnimatedStyle,
} from "react-native-reanimated";
import { SortProps } from "../types";
import { useSortable } from "../useSortable";

type Props = SortProps & {
  renderItem: () => JSX.Element;
};

export function SortableItem({ renderItem, ...sortProps }: Props) {
  const { activeX, activeY, handleReposition } = useSortable(sortProps);

  const { order, itemWidth, itemHeight } = sortProps;

  useAnimatedReaction(
    () => JSON.stringify(order.value),
    (result, previous) => {
      if (result !== previous) {
        handleReposition();
      }
    }
  );

  const animatedStyle = useAnimatedStyle<any>(() => ({
    transform: [
      {
        translateX: activeX.value,
      },
      {
        translateY: activeY.value,
      },
    ],
    zIndex: 0,
  }));

  return (
    <Animated.View
      style={[
        {
          width: itemWidth,
          height: itemHeight,
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
        },
        animatedStyle,
      ]}
    >
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        {renderItem()}
      </View>
    </Animated.View>
  );
}
